import React from 'react';
import { type Editor, type Element } from 'slate';
import styles from './ElementToolbar.module.css';
import toolbarStyles from '../Toolbar/Toolbar.module.css';
import classnames from 'classnames';
import type Tool from '../../tools/Tool';
import ToolbarHDivider from './ToolbarHDivider';

interface ToolbarModalContainerProps {
  modalTool: typeof Tool;
  editor: Editor;
  element: Element;
  toolbarShowModal: (tool: typeof Tool) => void;
  toolbarHideModal: () => void;
}

// Render a container for a toolbar modal panel.
const ToolbarModalContainer: React.FC<ToolbarModalContainerProps> = ({
  modalTool,
  editor,
  element,
  toolbarShowModal,
  toolbarHideModal,
}) => {
  const ModalContent = modalTool.renderToolbarModal;

  const closeModal = () => {
    modalTool.handleModalClosed({ editor, element });
    toolbarHideModal();
  };

  return (
    <div className={styles.elementToolbarModal}>
      <div
        className={classnames(toolbarStyles.toolbarButton)}
        onClick={() => closeModal()}
      >
        <i className="fa-regular fa-chevron-left" />
      </div>
      <ToolbarHDivider />
      <div className={styles.elementToolbarModalContainer}>
        <ModalContent
          editor={editor}
          element={element}
          toolbarShowModal={toolbarShowModal}
          toolbarHideModal={toolbarHideModal}
        />
      </div>
    </div>
  );
};

export default ToolbarModalContainer;
